// client/src/services/csgoService.js

import authService from './authService';

const apiUrl = process.env.REACT_APP_API_URL || '/api';

const authHeaders = (extra = {}) => ({
  ...extra,
  Authorization: `Bearer ${authService.getToken()}`
});

// Helper unique pour tous les appels CS:GO (auth, 401, parsing, erreurs).
const request = async (path, { method = 'GET', body } = {}) => {
  const headers = authHeaders(body ? { 'Content-Type': 'application/json' } : {});
  const response = await fetch(`${apiUrl}/csgo${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined
  });
  if (response.status === 401) authService.handleUnauthorized();
  if (response.status === 204) return true;
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.message || `Erreur ${response.status} ${response.statusText}`);
  }
  return data;
};

const csgoService = {
  // Vue d'ensemble & historique
  getOverview: () => request('/overview'),
  getPortfolioHistory: () => request('/portfolio-history'),

  // Règlements hebdo au partenaire (weekStart = lundi, ISO)
  getWeekPayments: () => request('/week-payments'),
  setWeekPayment: (weekStart, paid, amountUsd) =>
    request(`/week-payments/${encodeURIComponent(weekStart)}`, {
      method: 'PUT',
      body: { paid, amountUsd }
    }),

  // Items (modèle item-centré)
  getItems: () => request('/items'),
  updateItem: (id, data) => request(`/items/${id}`, { method: 'PATCH', body: data }),

  // Imports & sync
  importSteam: (jsonText) => request('/import/steam', { method: 'POST', body: { jsonText } }),
  importCsfloat: (jsonText) => request('/import/csfloat', { method: 'POST', body: { jsonText } }),
  syncCsfloat: () => request('/sync/csfloat', { method: 'POST' }),
  syncSteam: () => request('/sync/steam', { method: 'POST' }),
  sync: () => request('/sync', { method: 'POST' }),

  // Plateformes externes (Skinswap, ...)
  getPlatforms: () => request('/platforms'),
  createPlatform: (data) => request('/platforms', { method: 'POST', body: data }),
  updatePlatform: (id, data) => request(`/platforms/${id}`, { method: 'PATCH', body: data }),
  deletePlatform: (id) => request(`/platforms/${id}`, { method: 'DELETE' }),
  syncPlatform: (id) => request(`/platforms/${id}/sync`, { method: 'POST' }),

  // Réglages
  getConfig: () => request('/config'),
  updateConfig: (data) => request('/config', { method: 'PATCH', body: data }),

  // Gambling
  getGambling: (limit = 20) => request(`/gambling?limit=${limit}`),
  getGamblingStats: () => request('/gambling/stats'),
  createGambling: (data) => request('/gambling', { method: 'POST', body: data }),
  deleteGambling: (id) => request(`/gambling/${id}`, { method: 'DELETE' })
};

export default csgoService;
